export { default as HeatmapControls, HEATMAP_DRAWER_ID } from './HeatmapControls';
